module.exports = __webpack_public_path__ + "4f08fe054983308d4ebd59d183b1a28d.svg";